import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Router from 'next/router';

import AccessibilityMeta from '@components/molecules/accessibility-meta/accessibilityMeta.withRedux';
import StyledHeaderModal from './headerModal.style';
import ModalHeader from '../header/modalHeader';
import ModalFooter from '../footer/modalFooter';
import SearchBar from '../search-bar/searchBar';
import Navigation from '../navigation/navigation';

import { navReset } from '../../../redux/actions/navigation';
import { searchReset } from '../../../redux/actions/search';
import { accessibilityReset } from '../../../redux/actions/accessibility';

const HeaderModal = ({ navIsOpen, searchIsOpen, closeModal, accessibilityIsOpen }) => {
  useEffect(() => {
    Router.events.on('beforeHistoryChange', closeModal);

    return () => {
      Router.events.off('beforeHistoryChange', closeModal);
    };
  });

  return (
    <StyledHeaderModal
      closeTimeoutMS={1000}
      isOpen={navIsOpen || searchIsOpen || accessibilityIsOpen}
      onRequestClose={() => closeModal(navIsOpen, searchIsOpen, accessibilityIsOpen)}
    >
      <div className="headerModal__background" />

      <div className="headerModal__content-wrapper">
        {searchIsOpen && <SearchBar />}
        {navIsOpen && <Navigation />}
        {accessibilityIsOpen && <AccessibilityMeta />}
      </div>
      <ModalHeader className="headerModal__header" />
      <ModalFooter className="headerModal__header" />
    </StyledHeaderModal>
  );
};

HeaderModal.propTypes = {
  // lang: PropTypes.string.isRequired,
  navIsOpen: PropTypes.bool.isRequired,
  searchIsOpen: PropTypes.bool.isRequired,
  accessibilityIsOpen: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  lang: state.app.pageData.lang,
  navIsOpen: state.navigation.isOpen,
  accessibilityIsOpen: state.accessibility.isOpen,
  searchIsOpen: state.search.isOpen
});

const mapDispatchToProps = dispatch => ({
  closeModal: (navIsOpen, searchIsOpen, accessibilityIsOpen) => {
    if (navIsOpen) {
      dispatch(navReset());
    }
    if (searchIsOpen) {
      dispatch(searchReset());
    }
    if (accessibilityIsOpen) {
      dispatch(accessibilityReset());
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderModal);
